<form [formGroup]="addressForm" class="address-form">
  <rkt-form [form]="addressForm" [fields]="addressFields" (modelChange)="onFormUpdate()" [model]="formModel"></rkt-form>
</form>
